import {
    DASHBOARD_HOME_PAGE_PREFERENCE,
    LANGUAGES_CODES,
    LANGUAGES,
} from "../../../hmodules/edit-profile/constants/home-page-preference/home-page-preference.constants.js";

angular.module('harriApp')
    .controller('SettingsController', ["$scope", "$state", "$stateParams", "$alert", "$rootScope", "hTransitions", "hFormReference", "$timeout", "httpHelper", "$q", "hUser", "$filter", "userPermissions", "brandServices", "googleMaps", "positionsDataService", "hFormsService", "dashboardsPrerequisiteService", "useSettingsNav",
        function ($scope, $state, $stateParams, $alert, $rootScope, hTransitions, hFormReference, $timeout, httpHelper, $q, hUser, $filter, userPermissions, brandServices, googleMaps, positionsDataService, hFormsService, dashboardsPrerequisiteService, useSettingsNav) {

    $scope.isTLMode = $state.is('appLayout.schedule.editprofile');
    $scope.user = hUser.data.user;
    $scope.SBMLChild = hUser.isSBMLChild();
    $scope.SBMLParent = hUser.isSBMLAdmin();
    $scope.permissions = {};
    $scope.isEmployer = hUser.isEmployer();
    $scope.emailIsVerified = true;
    $scope.isWebClient = (hUser.getUserContext() && hUser.getUserContext().brand_type === 'brand');
    $scope.userType = hUser.getUserType();
    $scope.activeSettingView = $filter('translate')('Talent acquisition');
    const settingsNavFactory = useSettingsNav($scope);

    let canViewHaloDashboard;
    let canViewRiskDashboard;
    let riskServiceSettings;
    let isRiskDashboardAvailable;
    let canViewSentimentEngagementDashboard;
    let canViewTalentAcquisitionDashboard;
    let isGlobalTalentPoolEnabled;
    let isRiskDetectionServicelEnabled;
    let availableTouchpointsLocales;
    let preferredTouchpointLocale;
    let canViewTouchpointsLanguages = false;
    let riskActivationType;

    $('body').removeClass('modal-open');

    $scope.$watch(function() {
        return hUser.isLoggedIn();
    }, function() {
        $scope.user = hUser.data.user;
        $scope.SBMLChild = hUser.isSBMLChild();
        $scope.SBMLParent = hUser.isSBMLAdmin();
        $scope.views = null;
        $scope.getUserSettings().then(function (userSettings) {
            $scope.userSettings = userSettings;
            initViews();
        });
    });



    if ($scope.isEmployer) {
        userPermissions.getBrandPolicy(hUser.getUserContext().brand_id)
            .then(function (policyParser) {
                $scope.hasManageArchivedLocationPermission = policyParser.brands(policyParser.ANY).has(userPermissions.PERMISSIONS.ACCESS_CLOSED_LOCATIONS);
            }).catch(function (err) {
            console.error(err);
        });
    }


    $scope.userSettings = [];

    $scope.getUserSettings = function (){
        var defer = $q.defer();
        var userSettings = [];
        var brandsIdsList = [];
        if (hUser.isEmployer() || !hUser.isMcdUKExternalAuth()) {
            userSettings.push({
                title: $filter("translate")("Basic Information"),
                view: 'basic_information',
                icon: 'fa-cogs',
                directive: 'basic-information-directive'
            });
        }
        if (hUser.isInterviewV2ServiceEnabled()) {
            userSettings.push( {title: $filter("translate")("Sync Calendar"), view:'sync_calendar', icon:'fa-calendar', directive:'sync-calendar-directive'});
        }
        userSettings.push( {title:$filter("translate")("Security & Privacy"), view:'security_privacy', icon:'fa-lock', directive:'security-privacy-directive'});
        userSettings.push( {title:$filter("translate")("Time & Geography"), view:'time_geography', icon:'fa-globe', directive:'time-geography-directive'});
        userSettings.push( {title:$filter("translate")("Notifications"), view:'email_notifications', icon:'fa-envelope', directive:'notifications-directive'});
        defer.resolve(userSettings)

        return defer.promise;
    };

    $scope.sendEmailVerification = function (){
        UserAPI.sendVerificationLink('EMAIL')
            .then(function (response) {
                if (response.status) {
                    HNotifications.show({
                        title: $filter("translate")("An email has been sent to your Email! Please check your inbox"),
                        desc: '',
                        icon: "fa-check",
                        type: "success",
                        timeout: 4000
                    });
                } else {
                    HNotifications.show({
                        title: $filter("translate")("Something went wrong! Please try again later"),
                        desc: '',
                        icon: "fa-times-circle",
                        type: "danger",
                        timeout: 4000
                    });
                }
            })
            .catch(function (err) {
                console.error(err);
                hAlert($filter("translate")("Error"), $filter("translate")("Something Went Wrong"));
            });
    };

    $scope.profileSettings = [
        {
            title: $filter("translate")("Basic Information"),
            view: 'basic_information',
            icon: 'fa-cogs',
            checkVisibility: () => hUser.isEmployer() || !hUser.isMcdUKExternalAuth(),
            directive: 'basic-information-directive'
        },
        {
            title: $filter("translate")("Security & Privacy"),
            view: 'security_privacy',
            icon: 'fa-lock',
            directive: 'security-privacy-directive'
        },
        {
            title: $filter("translate")("Time & Geography"),
            view: 'time_geography',
            icon: 'fa-globe',
            directive: 'time-geography-directive'
        },
        {
            title: $filter("translate")("Notifications"),
            view: 'email_notifications',
            icon: 'fa-envelope',
            directive: 'notifications-directive'
        },
        {
            title: $filter("translate")("Home page preference"),
            view: 'home_page_preference',
            icon: 'fa-home',
            checkVisibility: () => {
                return (
                    canViewHaloDashboard ||
                    isRiskDashboardAvailable ||
                    canViewSentimentEngagementDashboard ||
                    canViewTalentAcquisitionDashboard
                );
            },
            getForm: () => {
                const homePagePreferenceFormClass = hFormsService.getForm('HomePagePreferenceForm');
                const homePagePreferenceForm = new homePagePreferenceFormClass();

                homePagePreferenceForm.templateURL = '../hmodules/edit-profile/forms/home-page-preference/home-page-preference.form.html';
                homePagePreferenceForm.availableDashboards = getAvailableDashboards();


                return {
                    id: 'home_page_preference',
                    form: homePagePreferenceForm,
                };
            }
        },
        {
            title: $filter("translate")("Touchpoint language"),
            view: 'touchpoints_language',
            icon: 'fa-solid fa-language',
            checkVisibility: () => {
                return (
                    canViewTouchpointsLanguages
                );
            },
            getForm: () => {
                const touchpointLanguageFormClass = hFormsService.getForm('TouchpointLocaleForm');
                const touchpointLanguageForm = new touchpointLanguageFormClass();

                touchpointLanguageForm.templateURL = '../hmodules/edit-profile/forms/touchpoint-locale/touchpoint-locale.form.html';

                const preferredLocaleCode = preferredTouchpointLocale?.code || LANGUAGES_CODES.EN;
                const preferredLanguage = LANGUAGES.find(lan => lan.label === preferredLocaleCode);
                touchpointLanguageForm.setSelectedLanguage(preferredLanguage);

                return {
                    id: 'touchpoints_language',
                    form: touchpointLanguageForm,
                };
            }
        },
        {
            title: $filter("translate")("Work History"),
            view: 'work_history',
            icon: 'fa-briefcase',
            getForm: function () {
                var experienceForm = new ExperienceForm($scope, hUser.getUser().id, googleMaps, positionsDataService);
                experienceForm.templateURL = '../modules/hforms/experience/views/experience_form.html';
                experienceForm.type = experienceForm.TYPES.SETTINGS_WORK_HISTORY;

                return {
                    id: 'work_history',
                    form: experienceForm,
                }
            }
        },
        {
            title: $filter("translate")("Education"),
            view: 'education',
            form: 'application/education',
            icon: 'fa-graduation-cap',
            options: '{settings:true}',
            optional: true,
            directive: '',
            getForm: function () {
                var educationForm = new EducationForm($scope, hUser.getUser().id, googleMaps);
                educationForm.templateURL = '../modules/hforms/education/views/education_form.html';
                educationForm.setIsEducationDatesMandatoryFlag(true);
                return {
                    id: 'education',
                    form: educationForm,
                }
            }
        },
        {
            title: $filter("translate")("Skills"),
            view: 'skills',
            form: 'registration/skills',
            checkVisibility: () => hUser.isEmployer() || !hUser.isMcdUKExternalAuth(),
            icon: 'fa-check-square-o',
            options: '{settings:true}'
        },
        {
            title: $filter("translate")("Schedule"),
            view: 'schedule',
            form: 'registration/schedule',
            checkVisibility: () => hUser.isEmployer() || !hUser.isMcdUKExternalAuth(),
            icon: 'fa-clock-o',
            options: '{settings:true}',
            directive: 'h-form-remote-load schedule-settings'
        },
      {title:$filter("translate")("About Me"), view:'about', form:'registration/about', icon:'fa-info', options:'{settings:true}', directive:'h-form-remote-load'},
      {title:$filter("translate")("Media"), view:'media', form:'registration/user_media', icon:'fa-picture-o', options:'{headers:false, settings:true}', 'directive':'media-hosted-videos'},
        {
            title: $filter("translate")("References"),
            view: 'references',
            form: 'registration/references',
            icon: 'fa-phone-square',
            options: '{settings:true}',
            'directive': '',
            getForm: function () {
                var referencesForm = new ReferencesForm($scope, hUser);
                referencesForm.templateURL = '../modules/hforms/references/views/application_references_form.html';
                referencesForm.type = "settings_references";
                return {
                    id: 'references',
                    form: referencesForm,
                }
            }
        },
        {
            title: $filter("translate")("Talent scout"),
            view: 'talent_scout',
            form: 'settings/talent_scout',
            icon: '../images/svgs/talent_scout.svg',
            options: '{settings:true}',
            directive: 'talent_scout_directive',
            isSvgIcon: true,
            checkVisibility: () => $scope.showTalentScout,
        },
    ];
        if (hUser.isEmployer()) {
            brandServices.check(brandServices.SERVICES.INTERVIEW_V2, hUser.getEntryMode().brand_id, true)
                .then(function (isInterviewV2ServiceEnabled) {
                    if (isInterviewV2ServiceEnabled) {
                        $scope.profileSettings.splice(1, 0, {
                            title: $filter("translate")("Sync Calendar"),
                            view: 'sync_calendar',
                            icon: 'fa-calendar',
                            directive: 'sync-calendar-directive'
                        });
                    }
                });
        }
    $scope.tlProfileSettings = [
        {
            title:$filter("translate")("Security & Privacy"),
            view:'security_privacy',
            icon:'fa-lock',
            directive:'security-privacy-directive',
            checkVisibility: () => {
              return true;
            }
        },
        {
            title: $filter("translate")("Home page preference"),
            view: 'home_page_preference',
            icon: 'fa-home',
            checkVisibility: () => {
                if (hUser.isTopLevelContext()) return false;
                return (
                    canViewHaloDashboard ||
                    canViewRiskDashboard ||
                    canViewSentimentEngagementDashboard ||
                    canViewTalentAcquisitionDashboard
                );
            },
            getForm: () => {
                const homePagePreferenceFormClass = hFormsService.getForm('HomePagePreferenceForm');
                const homePagePreferenceForm = new homePagePreferenceFormClass();
                homePagePreferenceForm.availableDashboards = getAvailableDashboards(true);
                homePagePreferenceForm.templateURL = '../hmodules/edit-profile/forms/home-page-preference/home-page-preference.form.html';

                return {
                    id: 'home_page_preference',
                    form: homePagePreferenceForm,
                }
            }
        },
    ];

            const getAvailableDashboards = (isTL) => {
                const availableDashboards = [];
                const isRiskLiteMode = riskActivationType === 'LITE';

                const dashboards = [
                    {
                        condition: canViewHaloDashboard,
                        type: DASHBOARD_HOME_PAGE_PREFERENCE.HALO_DASHBOARD
                    },
                    {
                        condition: (isTL ? canViewRiskDashboard : isRiskDashboardAvailable) && !isRiskLiteMode,
                        type: DASHBOARD_HOME_PAGE_PREFERENCE.RISK_ANALYSIS
                    },
                    {
                        condition: canViewSentimentEngagementDashboard,
                        type: DASHBOARD_HOME_PAGE_PREFERENCE.HARRI_ENGAGE
                    },
                    {
                        condition: canViewTalentAcquisitionDashboard,
                        type: DASHBOARD_HOME_PAGE_PREFERENCE.TALENT_ACQUISITION_DASHBOARD
                    }
                ];

                dashboards.forEach(({condition, type}) => {
                    if (condition) availableDashboards.push(type);
                });

                return availableDashboards;
            };

    //brand settings
    $scope.brandSettings = [
        {title:$filter("translate")("General Settings"), view:'general_settings', icon:'fa-building', directive:'brand-general-settings-directive', checkVisibility: () => $scope.canManageBrandDetails},
        {title:$filter("translate")("User Management New"), view:'user_management', icon:'fa-user', directive:'user-management-settings-directive'},
        {title:$filter("translate")("Manage Permissions"), view:'manage_permissions', icon:"../images/manage_permissions.svg", directive:'manage-permissions-settings-directive', isSvgIcon: true},
        {title:$filter("translate")("Locations"), view:'locations', icon:'fa-map-marker', directive:'brand-locations-directive'},
        {title:$filter("translate")("Templates"), view:'job_templates', icon:'fa-file-text', directive: 'brand-job-templates-directive'},
        {title:$filter("translate")("Templates"), view:'hr_actions_templates', icon:'fa-file-text', directive: 'hr-actions-templates-directive'},
        {title:$filter("translate")("Templates"), view:'social_referral_templates', icon:'fa-file-text', directive: 'social-referral-templates-directive'},
        {title:$filter("translate")("Templates"), view:'harri_engage', icon:'fa-file-text', directive: 'engagement-settings-directive'},
        {title:$filter("translate")("Templates"), view:'crm', icon:'fa-file-text', directive: 'crm-directive'},
        {title:$filter("translate")("Templates"), view:'interview-questions-bank', icon:'fa-file-text', directive: 'interview-questions-bank-directive'},
        {title:$filter("translate")("Rejection Templates"), view:'rejection_templates', icon:'fa-ban', directive: 'brand-rejection-templates-directive'},
        {title:$filter("translate")("AMS Columns"), view:'manage_ams', icon:'fa-columns', directive:'brand-manage-ams-directive'},
        {title:$filter("translate")("Blocked Terminated Employees"), view:'blocked_terminated_employees', icon:'fa-list-alt', directive:'blocked-terminated-employees-directive'},
        {title: $filter("translate")("Reasons for skipping"), view: 'skip_reasons', icon: 'fa-ban', directive: 'brand-manage-ams-directive'},
        {title: $filter("translate")("Background Checks"), view: 'background_checks', icon: 'fa-vcard-o', directive: 'brand-background-checks-directive'},
        {title: "Toast " + $filter("translate")("positions Mapping"), view: 'pos_positions_mapping', icon: 'fa-briefcase', directive: 'brand-pos-positions-mapping-directive'},
        {title: $filter("translate")("Positions"), view: 'positions_settings', icon: 'fa-briefcase', directive: 'brand-positions-settings-directive'},
        {title: $filter("translate")("Emails Branding & Content"), view: 'emails_branding_settings', icon: 'fa-briefcase', directive: 'brand-emails-branding-settings-directive'},
        {title:$filter("translate")("Communication Emails"), view:'communication_emails', icon:'fa-reply-all', directive: 'brand-communication-emails-settings-directive'},
        {title:$filter("translate")("Notification Receipt"), view:'notification_receipt', icon:'fa-envelope-o ', directive: 'brand-notification-receipt-settings-directive'},
        {title:$filter("translate")("Reviews"), view:'reviews', icon:'fa-area-chart', directive: 'reviews-directive'},
        {title:$filter("translate")("Media"), view:'media', form:'registration/brand_media', icon:'fa-picture-o', options:'{headers:false, settings:true}', 'directive':'media-hosted-videos'},
        {title:$filter("translate")("Billing"), view:'billing', icon:'fa-credit-card', directive: 'brand-billing-directive'},
        {title:$filter("translate")("Add New Payment Method"), view:'new_brand_payment_method', directive:'new-brand-payment-method-directive'},
        {title:$filter("translate")("Equal Employment Opportunity"), view:'eeo_forms', icon:'fa-compass', directive:'manage-eeo-forms-directive'},
        {title:$filter("translate")("Candidate's data cleansing"), view:'manage_candidate_data_cleansing', icon:'fa-kit fa-regular-database-sparkle', directive:'manage-candidate-data-cleansing-settings-directive'},
        {title:$filter("translate")("ATR"), view:'atrs_management', icon:'fa-street-view', directive: 'atrs-settings-directive'},
        {title:$filter("translate")("Employee Referral Templates"), view:'employee_referral_messages_templates', icon:'fa-list', directive:'employee-referral-messages-templates-directive'},
        {title:$filter("translate")("Invite to Apply Templates"), view:'invite_to_apply_templates', icon:'fa-list', directive:'invite-to-apply-templates-directive'},
        {title:$filter("translate")("Document Management"), view:'document_uploader', icon:'fa-file', directive:'document-uploader-directive'},
        {title:$filter("translate")("Approval Flow"), view:'approval_flow', icon:'fa-check', directive: 'approval-flow-settings-directive'},
        {title:$filter("translate")("Carri"), view:'carri_settings', icon:'fa-comments-o', directive: 'carri-settings-directive'},
        {title:$filter("translate")("Minimum Age For Minors"), view:'minimum_minor_age_settings', icon:'fa-file-text-o', directive: 'minimum-minor-age-directive'},
        {title:$filter("translate")("Automated Metrics"), view:'automated_metrics', icon:'fa-university', directive: 'brand-automated-metrics-directive'},
        {title:$filter("translate")("Documents Default Fields"), view:'documents_default_fields_settings', icon:'fa-file-text-o', directive: 'documents-default-fields-directive'},
        {title: $filter("translate")("CommsHub"), view: 'communication-hub-settings', iconCss: 'comms-hub-icon', icon: '', directive: 'communication-hub-settings-directive'},
        {title: $filter("translate")("Reports"), view: 'reports-settings', icon: 'fa-file-text', directive: 'reports-settings-directive'},
        {title: $filter("translate")("Custom Candidate's Source"), view: 'custom_sources', icon: 'fa-file-text', directive: 'custom-sources-directive'},
        {title: $filter("translate")("Career site builder"), view: 'career_site_builder', icon: 'fa-desktop', directive: 'career-story-settings-directive'},
        {title: $filter("translate")("Apply to Talent Pool"), view: 'apply_to_talent_pool_settings', icon: '../images/svgs/talent_pool_filled.svg', directive: 'apply-to-talent-pool-directive', isSvgIcon: true},
        {title: $filter("translate")("Automated onboarding"), view: 'automated_onboarding', icon: 'fa-gears', directive: 'automated-onboarding-settings-directive'},

    ];

    var editProfile = false;
    var allViews = [];

    $scope.$on('brandSettingsNavigation.next', function () {
        HNotifications.show({
            title: $filter("translate")("Settings saved successfully") + '.',
            desc: '',
            icon: "fa-check",
            type: "success",
            timeout: 4000
        });
    });


    //load user brands
    $scope.brands = [];


    var setSelectedView = function (view) {
        $scope.selectedViewInfo = $scope.views && $scope.views.find(function (viewObj) {
            return viewObj.view === view;
        });
        $scope.selectedView = view;
        $scope.refreshingSettings = false;
    };


    var loadSettings = function (brandId, View) {
        if (View) {
            setSelectedView(View);
        }
        if (brandId) {
            $scope.brand_id = brandId;
        }
        //default - select the first view
        if(!$scope.selectedView && $scope.userSettings && $scope.userSettings.length) {
            setSelectedView($scope.userSettings[0].view);
        }

        var viewFileName = getFormFullName($scope.selectedView, $scope.brand_id >= 0);

        hFormReference.getForm(viewFileName).then(function(formObj) {
            var scope = formObj.scope;

            if($scope.brand_id && $scope.brands[$scope.brand_id]) {
                scope.media_brand_id =$scope.brand_id;

                //wait until the backend return the brand slug
                scope.media_brand_slug = $scope.brands[$scope.brand_id].slug;

                $timeout(function() {
                    try {
                        //scroll to the selected item
                        $('.settings-left-bar .side-bar-scroll ').scrollTo($('.active').closest('.brand-menu-row'), {duration:'slow', offsetTop : '100'});
                    } catch(e) {}
                });

            }


            scope.goto(viewFileName);
            $scope.refreshingSettings = false;
        });
    };

    var unhookTransitionSuccess = hTransitions.onSuccess({}, function (trans) {
        trans.promise
            .finally(function () {
                if (!$scope.$destroyed) {
                    var toParams = trans.params('to');
                    loadSettings(toParams.brand_id, toParams.view);
                }
            });

    });


    function getFormFullName(view, isBrand) {

        var views =  allViews;//_.union($scope.userSettings, $scope.profileSettings, $scope.brandSettings);
       for(var k in views) {
            var setting = views[k];
            if(setting.view == view) {
                return getFormName(setting);
            }
        }

        return getViewFullName(view);
    }

    function getFormName(SettingsObj) {
        return SettingsObj.form ? SettingsObj.form : getViewFullName(SettingsObj.view)
    }

    function getViewFullName(name) {
        return 'settings/'+name;
    }

    const getAvailableTemplatesRoute = async (currentView) => {
        let templatesObj;
        for (let i = 0; i < settingsNavFactory.settingsNav?.[0]?.sections.length; i++) {
            let section = settingsNavFactory.settingsNav[0].sections[i];
            for (let j = 0; j < section.items?.length; j++) {
                let item = section.items[j];
                if (item.views?.includes(currentView)) {
                    templatesObj = item;
                    break;
                }
            }
            if (templatesObj) { break; }
        }

        if (templatesObj) {
            let isTemplatesAvailable = await templatesObj.isVisible();
            if (isTemplatesAvailable) {
                return templatesObj.href()
            }
        }

        return '';
    }

    const initViews = async () => {
        $scope.refreshingSettings = true;
        if ($scope.isEmployer) {
            const brandId = hUser.getEntryMode().brand_id;
            const userHighestBrandAccess = hUser.getUserHighestBrandAccess();
            const activeBrandId = userHighestBrandAccess.brand_id || userHighestBrandAccess.id;

            isRiskDetectionServicelEnabled = await brandServices.check(brandServices.SERVICES.RISK_DETECTION, brandId, true);

            const promises = [
                dashboardsPrerequisiteService.canViewHaloDashboard(activeBrandId),
                dashboardsPrerequisiteService.canViewRiskDashboard(activeBrandId),
                dashboardsPrerequisiteService.canViewSentimentEngagementDashboard(activeBrandId),
                dashboardsPrerequisiteService.canViewTalentAcquisitionDashboard(activeBrandId),
                HarriEngageServiceAPI.getAvailableLocales(),
                HarriEngageServiceAPI.getPreferredLocale(),
            ];

            if (isRiskDetectionServicelEnabled) {
                promises.push(
                    ReportingSettingsManagementAPI.getServiceSettings(brandId, brandServices.SERVICES.RISK_DETECTION)
                        .catch((error) => {
                            console.error('Failed to fetch risk service settings:', error);
                            return null;
                        })
                );
            }

            const results = await Promise.all(promises);

            [
                canViewHaloDashboard,
                canViewRiskDashboard,
                canViewSentimentEngagementDashboard,
                canViewTalentAcquisitionDashboard,
                availableTouchpointsLocales,
                preferredTouchpointLocale,
                riskServiceSettings,
            ] = results;

            riskActivationType = riskServiceSettings?.activation_settings?.type;

            canViewTouchpointsLanguages = availableTouchpointsLocales?.length > 1;

            isRiskDashboardAvailable = isRiskDetectionServicelEnabled && canViewRiskDashboard;

            if ($state.is('appLayout.harriSH.editprofile')) {

                isGlobalTalentPoolEnabled = await brandServices.check(brandServices.SERVICES.GLOBAL_TALENT_POOL, brandId);

                if (isGlobalTalentPoolEnabled) {
                    const res = await TalentPoolAPI2.getBrandTalentPoolSettings(brandId);
                    if (res.apply_to_talent_pool && res.enable_talent_scout) {
                        $scope.showTalentScout = true;
                    }
                }
            }
        } else if ($state.is('appLayout.harriSH.editprofile')) {
            [
                availableTouchpointsLocales,
                preferredTouchpointLocale

            ] = await Promise.all([
                HarriEngageServiceAPI.getAvailableLocales(),
                HarriEngageServiceAPI.getPreferredLocale(),
            ]);

            canViewTouchpointsLanguages = availableTouchpointsLocales?.length > 1;
        }

        if (hUser.isEmployer()) {
            const activeBrandId = hUser.getActiveBrandIdWithAccess();

            const [
                policyParser,
                isJobDistributorEnabled
            ] = await Promise.all([
                userPermissions.getBrandPolicy(activeBrandId),
                brandServices.check(brandServices.SERVICES.JOB_DISTRIBUTOR, activeBrandId)
            ]);

            $scope.canManageBrandDetails = (
                policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) &&
                (
                    policyParser.has(userPermissions.PERMISSIONS.MANAGE_BRAND_DETAILS) ||
                    (
                        isJobDistributorEnabled &&
                        policyParser.has(userPermissions.PERMISSIONS.DISTRIBUTE_BOOST_JOB_POST)
                    )
                )
            );
        }

        if ($state.is('appLayout.schedule.editprofile')) {
            editProfile = true;
            allViews = $scope.tlProfileSettings;
        }
        else if ($state.is('appLayout.harriSH.editprofile')) {
            editProfile = true;
            allViews = _.union($scope.profileSettings);
        } else if (!$scope.isEmployer) {
            editProfile = false;
            allViews = _.union($scope.userSettings);
        } else {
            editProfile = false;
            allViews = _.union($scope.brandSettings);
        }

        allViews = allViews.filter((view) => !view.checkVisibility || view.checkVisibility());

        $scope.editProfile = editProfile;

        $scope.views = _.uniq(
            _.map(
                allViews,
                function (setting) {
                    return {
                        form: getFormName(setting),
                        title: setting.title,
                        directive: setting.directive,
                        options: setting.options,
                        optional: setting.optional,
                        view: setting.view,
                        getForm: setting.getForm,
                    };
                }
            )
        );

        if (!$state.is('appLayout.schedule.editprofile')) {
            $scope.views.push({
                form: 'registration/hosted_video',
                options: '{settings:true}',
                view: 'hosted_video'
            });
        }

        var selectedView = angular.copy($scope.selectedView);
        var brandId = angular.copy($scope.brand_id);

        if (!selectedView && $stateParams.view) {
            selectedView = $stateParams.view;
        }

        if (!brandId && $stateParams.brand_id) {
            brandId = $stateParams.brand_id;
        }

        if (selectedView) {
            if (!editProfile && $scope.isEmployer) {
                let isAvailable = await settingsNavFactory.isViewAvailable(selectedView);
                if (!isAvailable) {
                    let templatesViewsList = [
                        "job_templates",
                        "atr_templates",
                        "hr_actions_templates",
                        "social_referral_templates",
                        "harri_engage",
                        "crm",
                        "interview-questions-bank",
                        "reference_request_templates",
                    ]

                    let firstAvailableItem;
                    if (templatesViewsList.includes(selectedView)) {
                        let tempRoute = await getAvailableTemplatesRoute(selectedView);
                        if (tempRoute) {
                            // Extract the view name from the href URL since templates object has views array, not single view
                            const match = tempRoute.match(/\/settings\/([^?&#]+)/);
                            const viewFromHref = match ? match[1] : null;

                            if (viewFromHref) {
                                $state.go('appLayout.harriSH.settings.brandSection', {view: viewFromHref}, {inherit: false});
                            } else {
                                window.location.href = tempRoute;
                            }
                            return;
                        }
                        firstAvailableItem = await settingsNavFactory.getFirstAvailableItem();
                    } else {
                        firstAvailableItem = await settingsNavFactory.getFirstAvailableItem();
                    }

                    if (!firstAvailableItem) {
                        console.warn('No available item found for the selected view:', selectedView);
                        $state.go('appLayout.harriSH.dashboard');
                        return;
                    }
                    
                    const routeDetails = settingsNavFactory.getItemRoutingDetails(firstAvailableItem);

                    if (routeDetails.type === 'EXTERNAL') {
                        window.location.href = routeDetails.href;
                    } else {
                        $state.go(routeDetails.state, routeDetails.params, routeDetails.options);
                    }
                } else {
                    loadSettings(brandId, selectedView);
                }
            } else {
                loadSettings(brandId, selectedView)
            }
        } else {
            setSelectedView('');
            $scope.brand_id = '';
        }

        SettingsAPI.loadPersonalInformation()
            .then(function (res) {
                $scope.emailIsVerified = res.email && res.email_status === 'VERIFIED';
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
                $scope.$digest();
            });

    };

    $scope.views = null;

    $scope.getUserSettings().then(function (userSettings) {
        $scope.userSettings = userSettings;
        initViews();
    });

    const brandsListUpdatedEvent = hUser.onBrandsListUpdated(async () => {
        $scope.views = null;
        await initViews();
        $scope.$digest();
    });

    $scope.$on("$destroy", function () {
        unhookTransitionSuccess();
        brandsListUpdatedEvent && hUser.off(brandsListUpdatedEvent);
    });

}])



.directive('locationSettings', ["hFormReference", "httpHelper", "$stateParams", "$filter", function(hFormReference, httpHelper,$stateParams,$filter) {

    return {
        link: function(scope, element, atts) {

            scope.removeLocation = function(location_id, item) {
                httpHelper.g('brand/delete_location/'+ location_id).then(function(result) {
                    scope.forms.brand_loc.errorMessage = "";
                    scope.forms.brand_loc.successMessage = "";
                    if(result.data.status == "Error"){
                        scope.forms.brand_loc.errorMessage = result.data.data;
                    }else{
                        scope.forms.brand_loc.successMessage = result.data.data;
                        $('#location_id_'+location_id).remove();

                    }
                })
            };
            scope.add_location = function() {
                var dataToPut = {};
                dataToPut.brand_id = scope.data.brand_loc.brand_id;
                dataToPut.google_location = scope.data.brand_loc.google_location;
                httpHelper.put('brand/location', dataToPut).then(function(result) {
                    scope.forms.brand_loc.errorMessage = "";
                    scope.forms.brand_loc.successMessage = "";
                    if(result.data.status == "Error"){
                        scope.forms.brand_loc.errorMessage = result.data.data[0].error;
                    }else{
                        scope.forms.brand_loc.successMessage = $filter("translate")("Location is added successfully !");
                    }
                })
            }
        }
    }
}]);

/*    JobAppAPIs://saveWorkHistories   */
app.factory('JobAppAPIs', ["httpHelper", "$q", function (httpHelper, $q) {
    var APIs = {
        saveEducation: function (data) {
            var defer = $q.defer();

            var basic_data = [keepAttrs(angular.copy(data), ['institution_name', 'google_place'])];

            httpHelper.put('user_education', basic_data).then(function (r) {
                var extended_data = removeAttrs(angular.copy(data), ['institution_name', 'google_place']);
                if (r && r.data && r.data.data && r.data.data.UserEducation && r.data.data.UserEducation.id) {
                    extended_data.education_id = r.data.data.UserEducation.id;
                    httpHelper.p('user_education', extended_data).then(function (r) {
                        defer.resolve(r);
                    })
                }
            });

            return defer.promise;
        },
        skills: function (data) {
            if (!data || data == undefined || (angular.isArray(data) && data.length == 0)) {
                var defer = $q.defer();
                defer.resolve();
                return defer.promise;
            }
            return httpHelper.put('user_skills', data);
        },

        aboutme: function (data) {
            if (!data || data == undefined || (angular.isArray(data) && data.length == 0)) {
                var defer = $q.defer();
                defer.resolve();
                return defer.promise;
            }
            return httpHelper.put('profile_details', data);
        },

        dummy: function (data) {
            var defer = $q.defer();
            defer.resolve();
            return defer.promise;
        }



    };
    return APIs;
}]);
